var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1172 31.7642H38.8819V36.1759H37.1172V31.7642Z",
    fill: "#E86A0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6456 31.7642V37.9406H35.3514V31.7642H30.8809V44.9995H44.9985V31.7642H40.6456Z",
    fill: "#E86A0D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9414 14.9995H30.0002V18.5877H22.9414V14.9995Z",
    fill: "#E86A0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9412 16.8237H31.7647V20.3531H21.1765V16.8237H15V45.0002H29.1176V30.0002H37.9412V16.8237ZM21.5194 41.1598L19.1342 38.7746L20.3821 37.5268L21.5194 38.6641L25.1226 35.0609L26.3704 36.3087L21.5194 41.1598ZM26.4706 31.8237H19.4118V30.059H26.4706V31.8237ZM33.5294 28.2943H19.4118V26.5296H33.5294V28.2943ZM33.5294 24.7649H19.4118V23.0002H33.5294V24.7649Z",
    fill: "#E86A0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageOrders);
export default __webpack_public_path__ + "static/media/manage-orders.530a48bc151819b7595c28e4e55fffed.svg";
export { ForwardRef as ReactComponent };